export const API_ENDPOINTS = {

    /*=======*/
    USER_EXISTS: "/api/users/exists",
    USER_CREATE: "/api/users/create",
    GET_PROFILE: "/api/users/get-profile",
    SAVE_AGREEMENT: "/api/agreements/save_agreement",
    GET_AGREEMENTS: "/api/agreements/get_agreements",
    DELETE_ID_CANCELLED: "/api/agreements/cancel_agreement",
    GET_DASHBOARD: "/api/users/dashboard",
    GET_RECIPIENT: "/api/users/get_getinge_users",
    GET_EDIT_AGREEMENTS_ID: "/api/agreements/get_agreement/",
    SEND_AGREEMENT_RECIPIENT: "/api/agreements/send_agreement",
    GET_DOWNLOAD_DOCUMENT: "/api/agreements/download",
    GET_PREVIEW_DOCUMENT: "/api/agreements/preview",
}

